import { baseApi } from "@/config/http-common";

class ProcessUserDataService {
  getAll(filter: any): Promise<any> {
    return baseApi.get("/documents/process-user/list", { params: filter });
  }

  get(id: string): Promise<any> {
    return baseApi.get(`/documents/process-user/view/${id}`);
  }

  execute(
    processUserId: string,
    executionType: "EXECUTE" | "DENY" | "REWORK",
    comment: string
  ): Promise<any> {
    return baseApi.post("/documents/process-user/execute", {
      processUserId,
      executionType,
      comment,
    });
  }

  getSignManifest(processUserId: string): Promise<any> {
    return baseApi.get(
      `/documents/process-user/sign-manifest/${processUserId}`
    );
  }

  signFile(
    processUserId: string,
    fileGuid: string,
    signGuid: string
  ): Promise<any> {
    return baseApi.post("/documents/process-user/save-sign", {
      processUserId,
      fileGuid,
      signGuid,
    });
  }

  signManifest(
    processUserId: string,
    signGuid: string
  ): Promise<any> {
    return baseApi.post("/documents/process-user/save-sign", {
      processUserId,
      signGuid,
    });
  }

  initMobileSign(processUserId: string): Promise<any> {
    return baseApi.post(
      `/documents/process-user/mobile-sign/init/${processUserId}`,
      null,
      { silent: true } as any
    );
  }

  getMobileSignStatus(processUserId: string): Promise<any> {
    return baseApi.get(
      `/documents/process-user/mobile-sign/status/${processUserId}`,
      { silent: true } as any
    );
  }

  getActiveMobileSign(processUserId: string): Promise<any> {
    return baseApi.get(
      `/documents/process-user/mobile-sign/active/${processUserId}`,
      { silent: true } as any
    );
  }

  cancelMobileSign(processUserId: string): Promise<any> {
    return baseApi.post(
      `/documents/process-user/mobile-sign/cancel/${processUserId}`,
      null,
      { silent: true } as any
    );
  }

  prolongExternalLink(processUserId: string, ttlMinutes = 1440): Promise<any> {
    return baseApi.post(
      `/documents/process-user/external-link/prolong/${processUserId}`,
      null,
      { params: { ttlMinutes } }
    );
  }
}

export default new ProcessUserDataService();
